export default __webpack_public_path__ + "static/media/pdvs-trabalhar.83958dfe.svg";